import { render, staticRenderFns } from "./Table1.vue?vue&type=template&id=733a1a7f&"
import script from "./Table1.vue?vue&type=script&lang=js&"
export * from "./Table1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports